<template>
  <b-navbar>
    <template #start>
      <b-navbar-item tag="router-link" :to="{ name: 'Home' }">
        Главная
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'Combo' }">
        Комбо
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'Promo' }">
        Акции
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'Update' }">
        Обновления
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'WhatsAppAccounts' }">
        WhatsApp
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'DeliveryNotificationMessagesIndex' }">
        Уведомления
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'Settings' }">
        Настройки
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: 'AppNavbar',
};
</script>

<style scoped>

</style>
